<template>
    <span>
        <el-button type="primary" size="small" @click="dialogVisible = true">{{buttonName}}</el-button>
        <el-dialog title="地址信息" :visible="dialogVisible" center :before-close="handleCloseDialog">
            <el-form :model="form" ref="form" :rules="rules">
                <el-form-item label="收件人姓名" :label-width="formLabelWidth" prop="name" >
                    <el-input v-model="form.name"  auto-complete="off" placeholder="请输入收件人姓名" ></el-input>
                </el-form-item>
                <el-form-item label="联系方式" :label-width="formLabelWidth" prop="mobile">
                    <el-input v-model="form.mobile" auto-complete="off" placeholder="请输入联系方式"></el-input>
                </el-form-item>
                <DistrictLinkage
                    :itemLabelWidth="formLabelWidth" 
                    :provinceId="parseInt(form.province_id)"
                    :cityId="parseInt(form.city_id)"
                    :districtId="parseInt(form.district)"
                    @change="handleChange">
                </DistrictLinkage>
                <el-form-item label="地址" :label-width="formLabelWidth" prop="address" >
                    <el-input v-model="form.address" auto-complete="off" placeholder="请输入详细地址"></el-input>
                </el-form-item>
                <el-form-item label="邮寄方式" :label-width="formLabelWidth" prop="express_company">
                    <el-select v-model="form.express_company" placeholder="请选择">
                        <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注信息" :label-width="formLabelWidth">
                    <el-input v-model="form.memo" auto-complete="off"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCloseDialog">关闭</el-button>
                <el-button type="primary" @click="handleSubmit" :loading="loading">保存</el-button>
            </div>
        </el-dialog>
    </span>
</template>
<script>
import OrderService from '~/services/order';
import OrderExpressService from '~/services/OrderExpress';
import DistrictLinkage from "~/widgets/DistrictLinkage.vue";
export default {
props:{
    expressForm: null,
    buttonName:{
        type: String,
        required: true,
        default: ''
    },
},
components:{
    DistrictLinkage
},

data() {
    var validateMobile = (rule, value, callback) => {
        if (!value) {
            // 如果手机号为空，则返回错误信息
            callback(new Error('请输入联系方式'));
        } else {
            // 正则表达式匹配中国的手机号码格式
            const mobileRegex = /^1[3-9]\d{9}$/;
            if (mobileRegex.test(value)) {
                // 符合格式，调用 callback 并传入 null 表示校验通过
                callback();
            } else {
                // 不符合格式，返回错误信息
                callback(new Error('请输入正确的手机号码'));
            }
        }
    };
    return {
        dialogVisible:false,
        options: [],
        form: {
            id:'',
            status:0,
            express_company:'',
            express_no:'',
            name:'',
            mobile:'',
            address:'',
            province_id: 0,
            city_id: 0,
            district: 0,
        },
        rules: {
            status: [
                { required: true, message: '请选择快递状态', trigger: 'blur' },
            ],
            // express_company: [
            //     { required: true, message: '请选择邮寄方式', trigger: 'blur' },
            // ],
            express_no: [
                { required: true, message: '请输入订单号', trigger: 'blur' },
            ],
            name:[
                { required: true, message: '请输入收件人', trigger: 'blur'  }
            ],
            mobile:[
                { required: true, validator: '请输入联系方式', trigger: 'blur'  },
                { validator: validateMobile, trigger: 'blur' }
            ],
            address:[
                { required: true, message: '请输入详细地址', trigger: 'blur'  }
            ],
            province_id: [{required: true, message: "请选择所在地区", trigger: "change"}],
            city_id: [{required: true, message: "请选择所在地区", trigger: "change"}],
            district: [{required: true, message: "请选择所在地区", trigger: "change"}],
        },
        formLabelWidth: '100px', 
        loading: false
    };
},
created() {
    this.options = OrderService.options();
    if (this.expressForm) {
        this.form = Object.assign({}, this.expressForm)
    }
},
methods:{
    handleSubmit(){
        this.$refs["form"].validate(valid => {
            if (valid) {
                this.loading = true;
                if (this.expressForm){
                    OrderExpressService.update(this.form).then(res => {
                        if (res.code == 0) {
                            this.$message({
                                message:'编辑成功',
                                type:'success'
                            });
                        }
                        this.$emit("change", this.form);
                        this.handleCloseDialog();
                        this.loading = false;
                    }).catch(() => {
                        this.loading = false;
                    });
                }
            } else {
                return false;
            }
        });
    },

    handleCloseDialog(){
        this.dialogVisible = false;
    },

    handleChange(value) {
        this.form.province_id = parseInt(value[0]);
        this.form.city_id = parseInt(value[1]);
        this.form.district = parseInt(value[2]);
    },
}
}
</script>




// WEBPACK FOOTER //
// src/views/order/dialog/expressForm.vue